import React from 'react'
import css from './Footer.module.css';
import Logo from '../../assets/logo.png';
import { 
            LocationMarkerIcon,
            PhoneIcon,
            InboxIcon,
            LoginIcon,
            UsersIcon,
            LinkIcon,
 } from '@heroicons/react/outline';

const Footer = () => {
  return (
    <div className={css.cFooterWrapper}>
     
     <hr />

     <div className={css.cFooter}>
        <div className={css.logo}>
            <img src={Logo} alt="" />
            <span>AguStore</span>
        </div>

        <div className={css.block}>
            <div className={css.details}>
                <span>Contact US</span>
                <span className={css.pngLine}>
                    <LocationMarkerIcon  className={css.icon} />
                    <span>17 Umuonaje Quarters, Asaba, 329231</span>
                </span>
                <span className={css.pngLine}>
                    <PhoneIcon  className={css.icon} />
                    <a href='tel:+2348160733986'>+2348160733986</a>
                </span>
                <span className={css.pngLine}>
                    <InboxIcon  className={css.icon} />
                    <a href='mailto:contact@agu.dev'>contact@agu.dev</a>
                </span>

            </div>
        </div>

        <div className={css.block}>
            <div className={css.details}>
                <span>Account</span>
                <span className={css.pngLine}>
                    <LoginIcon  className={css.icon} />
                    <a href='/signin'>
                    <p>Sign In</p>
                    </a>
                </span>
                
            </div>
        </div>

        <div className={css.block}>
            <div className={css.details}>
                <span>Company</span>
                <span className={css.pngLine}>
                    <UsersIcon  className={css.icon} />
                    <a href='/about'>
                    <p>About US</p>
                    </a>
                </span>
                
            </div>
        </div>

        <div className={css.block}>
            <div className={css.details}>
                <span>Resources</span>
                <span className={css.pngLine}>
                    <LinkIcon  className={css.icon} />
                    <a href='/terms'>
                    <p>Terms & Privacy</p>
                    </a>
                </span>
                
            </div>
        </div>


     </div>

     <div className={css.copyRight}>
            <span>Copyright ©2024 by AguStore, Inc.</span>
            <span>All Rights Reserved.</span>
        </div>
    </div>
  )
}

export default Footer
